import * as React from "react";
export class MbnIcon extends React.PureComponent {
    render() {
        const classMdf = this.props.modifier ? ` rj-mbn-icon--${this.props.modifier}` : "";
        return React.createElement("span", { className: `rj-mbn-icon rj-mbn-icon--${this.props.tagNumber}${classMdf}`, "data-uat": "mbn-icon" }, this.props.tagNumber);
    }
}
export function MarketMbnIcon(props) {
    return React.createElement(MbnIcon, { tagNumber: props.tagNumber, modifier: "market" });
}
//# sourceMappingURL=MbnIcon.js.map